import React, { useState, useEffect, useContext } from 'react';
import './EvaluationsStatistics.css';
import axios from 'axios';
import Sidebar from '../../webAppComponents/Sidebar/Sidebar';
import AuthContext from '../../context/AuthContext';
import { useTranslation } from "react-i18next";

import BckLogo from '../../webAppAssets/BackgroundLogo.svg';

import TrainingsPageChanger from '../../webAppComponents/TrainingsPageChanger/TrainingsPageChanger'
import GraphsEvaluations from '../../webAppComponents/GraphsEvaluations/GraphsEvaluations';
import { use } from 'i18next';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function EvaluationsStatistics() {
    const [graphicsData,setGraphicsData] = useState({
        labels: [],
        graph1: {
          bar1: [],
          bar2: [],
          bar3: [],
          bar4: []
        },
        graph2: {
          line: [],
          bar1: [],
          bar2: []
        },
        graph3: {
          line: [],
          bar1: [],
          bar2: [],
          bar3: [],
        },
        graph4: {
          line: [],
          bar1: [],
          bar2: []
        }
      })

  const { t } = useTranslation(['evaluations-page']);
  const [ verticalFilters, setVerticalFilters] = useState([
    {"name": "Position", "content": [{"value": "Goalkeeper", "label":"GK"},{"value": "Centre-back", "label":"CB"},{"value": "Left-back", "label":"LB"},{"value": "Right-back", "label":"RB"},{"value": "Defensive Midfielder", "label":"CDM"},{"value": "Central midfielder", "label":"CM"},{"value": "Attacking midfielder", "label":"CAM"},{"value":"Left midfielder", "label":"LM"},{"value":"Right midfielder","label":"RM"},{"value": "Left winger", "label":"LW"},{"value": "Right winger", "label":"RW"},{"value":"Center forward", "label":"CF" },{"value": "Striker", "label":"ST"}]},
    {"name" : "Name", "content": []},
    {"name": "Evaluation", "content": []}]);


  const [teamData, setTeamData] = useState([]);
  const [playerData, setPlayerData] = useState([]); // evaluations of all players
  const [rendering, setRendering] = useState(true);
  const [selectedPlayer, setSelectedPlayer] = useState(-1); // selected player id
  const [selectedEvaluations, setSelectedEvaluations] = useState([]); // selected evaluations ids

  const { authTokens } = useContext(AuthContext);

  // Define the headers with the Bearer token
  const headers = {
    Authorization: `Bearer ${authTokens.access}`,
  };



  const getData = () => { 
      // Make a GET request for player evaluations
      axios.get(
        process.env.REACT_APP_BACKEND + 'evaluations', 
        { headers }
      )
      .then((response) => {
        const data = response.data;
        setPlayerData(data);
        // console.log(data);
  
      // After fetching evaluations, make another request to get team info
      axios.get(process.env.REACT_APP_BACKEND + 'users/list-players', { headers })
      .then((teamResponse) => {
        const teamData = teamResponse.data;
        setTeamData(teamData); // Set teamData state
        //console.log("Team data:", teamData);
  
        // Add player info to the filters using the fetched team data
        const newFilters = [...verticalFilters];
        
        // Populate the filter with the fetched team data (position acronym and player names) and with Positions
        teamData.map((player) =>{
          //console.log(player)
          if (!newFilters[1].content.some(item => item.value === player.user.id)){ // for some reason players are also duplicate this avoids that
            newFilters[1].content.push({value: player.user.id, label: `${player.user.first_name} ${player.user.last_name}`, pos: player.position });
          }
          if (!newFilters[0].content.some(item => item.value === player.position)) { // avoid position repetition
            newFilters[0].content.push({ value: player.position, label: player.position_acronym });
          }
        })
        
        //console.log(newFilters)
        
        setVerticalFilters(newFilters); // Update vertical filters
        //console.log("Updated vertical filters:", newFilters);
      })
      .catch((error) => {
        console.error("Error fetching team data:", error);
      });
    })
    .catch((error) => {
      console.error("Error fetching player evaluations:", error);
    });
  
  }


  // Uncheck all inputs for a specific filter type (e.g., Name filter)
  const uncheckInputs = (filterName) => {
    // Find all inputs with the matching name attribute
    const inputs = document.querySelectorAll(`input[name="${filterName}"]`);

    // Loop over the NodeList and set checked to false for each
    inputs.forEach(input => {
      input.checked = false;
    });
  };



  const handleVerticalFilter = (filterName, value) => {
    if (filterName === "Position") {
      //console.log("Position filter selected:", value);

      renderGraphicsData("reset", null);
  
      // Filter players based on the selected position
      const filteredPlayers = teamData.filter(player => player.position === value);
  
      // Find the Name filter and update it with the filtered players based on position
      const updatedVerticalFilters = verticalFilters.map(filter => {
        if (filter.name === "Name") {
          return {
            ...filter,
            content: filteredPlayers.map(player => ({
              value: player.user.id,
              label: `${player.user.first_name} ${player.user.last_name}`,
              pos: player.position,
            })),
          };
        }
        return filter;
      });

      // Clear selected player to reset the Name filter
      if (!filteredPlayers.some(player => player.user.id === selectedPlayer) && selectedPlayer !== -1) {
        // If the selected player is not in the filtered players, clear the selected player and reset the Evaluation filter
        setSelectedPlayer(-1);
        updatedVerticalFilters[2].content = [];
      }

      // Update the vertical filters to trigger the re-render
      setVerticalFilters(updatedVerticalFilters);
      uncheckInputs("Name");
      
      setSelectedEvaluations([]);
    } else if (filterName === "Name") {
      const nameFilter = verticalFilters.find(filter => filter.name === "Name");
  
      // Find the selected player
      const selectedPlayerData = nameFilter.content.find(player => player.value === Number(value));
  
      if (selectedPlayerData) {
        const playerId = selectedPlayerData.value;
  
        // Find player evaluation data and render graphics
        const playerEval = playerData.find(player => player.user_id === playerId);
  
        renderGraphicsData("reset", null);
        if (!playerEval) {
          toast.error(t("Player has no evaluations"));
        }

        const newFilters = [...verticalFilters];
         // Clear previous evaluations
        newFilters[2].content = [];

        let dateCount = {};
        // Count the number of evaluations for each date
        playerData.map((evaluation) => {
          if (playerId === evaluation.user_id) {
            if (!dateCount[evaluation.evaluation_form]) {
              dateCount[evaluation.evaluation_form] = 1;
            } else {
              dateCount[evaluation.evaluation_form]++;
            }
          }
        });

        let currentDateCount = {};
        playerData.map((evaluation) => {
          if (playerId === evaluation.user_id) {
            if (dateCount[evaluation.evaluation_form] > 1) {
              // Add something to the label if there are multiple evaluations for the same date
              currentDateCount[evaluation.evaluation_form] = (currentDateCount[evaluation.evaluation_form] || 0) + 1;
              newFilters[2].content.push({ value: evaluation.id, label: evaluation.evaluation_form + " - " + currentDateCount[evaluation.evaluation_form] });
            } else {
              newFilters[2].content.push({ value: evaluation.id, label: evaluation.evaluation_form });
            }
          }
        });

        setVerticalFilters(newFilters);
        setSelectedPlayer(playerId);
        setSelectedEvaluations([]);
      }

    } else if (filterName === "Evaluation") {
      const evaluationId = Number(value);
      const nameFilter = verticalFilters.find(filter => filter.name === "Name");
      const selectedPlayerData = nameFilter.content.find(player => player.value === selectedPlayer);

      if (selectedPlayerData) {
        const playerId = selectedPlayerData.value;
        const playerEval = playerData.find(evaluation => evaluation.user_id === playerId && evaluation.id === evaluationId);
        
        const evalChecked = selectedEvaluations.includes(evaluationId);
        let updatedEvaluations;
        if (evalChecked) {
          updatedEvaluations = selectedEvaluations.filter(id => id !== evaluationId);
          renderGraphicsData("remove", playerEval);
        } else {
          if (selectedEvaluations.length === 2) {
            updatedEvaluations = [selectedEvaluations[1], evaluationId];
            renderGraphicsData("replace", playerEval);
          } else {
            updatedEvaluations = [...selectedEvaluations, evaluationId];
            renderGraphicsData("add", playerEval);
          }
        }
        setSelectedEvaluations(updatedEvaluations);
        return updatedEvaluations;
      }
    }
  };
    

  const renderGraphicsData = (flag, playerEval) => {
    //console.log("Flag:", flag, "Player eval:", playerEval);
  
    const updatedGraphicsData = { ...graphicsData };
    if (flag === "replace") {
      // Remove the first entry. Assuming the first entry is the oldest one.
      updatedGraphicsData.labels.shift();
      updatedGraphicsData.graph1.bar1.shift();
      updatedGraphicsData.graph1.bar2.shift();
      updatedGraphicsData.graph1.bar3.shift();
      updatedGraphicsData.graph1.bar4.shift();
      updatedGraphicsData.graph2.line.shift();
      updatedGraphicsData.graph2.bar1.shift();
      updatedGraphicsData.graph2.bar2.shift();
      updatedGraphicsData.graph3.line.shift();
      updatedGraphicsData.graph3.bar1.shift();
      updatedGraphicsData.graph3.bar2.shift();
      updatedGraphicsData.graph3.bar3.shift();
      updatedGraphicsData.graph4.line.shift();
      updatedGraphicsData.graph4.bar1.shift();
      updatedGraphicsData.graph4.bar2.shift();

    } else if (flag === "remove") {
      // Remove the corresponding entry from the graphics data
      const label = verticalFilters[2].content.find(item => item.value === playerEval.id).label;
      const indexToRemove = updatedGraphicsData.labels.indexOf(label);
      if (indexToRemove !== -1) {
        updatedGraphicsData.labels.splice(indexToRemove, 1);
        updatedGraphicsData.graph1.bar1.splice(indexToRemove, 1);
        updatedGraphicsData.graph1.bar2.splice(indexToRemove, 1);
        updatedGraphicsData.graph1.bar3.splice(indexToRemove, 1);
        updatedGraphicsData.graph1.bar4.splice(indexToRemove, 1);
        updatedGraphicsData.graph2.line.splice(indexToRemove, 1);
        updatedGraphicsData.graph2.bar1.splice(indexToRemove, 1);
        updatedGraphicsData.graph2.bar2.splice(indexToRemove, 1);
        updatedGraphicsData.graph3.line.splice(indexToRemove, 1);
        updatedGraphicsData.graph3.bar1.splice(indexToRemove, 1);
        updatedGraphicsData.graph3.bar2.splice(indexToRemove, 1);
        updatedGraphicsData.graph3.bar3.splice(indexToRemove, 1);
        updatedGraphicsData.graph4.line.splice(indexToRemove, 1);
        updatedGraphicsData.graph4.bar1.splice(indexToRemove, 1);
        updatedGraphicsData.graph4.bar2.splice(indexToRemove, 1);

        setGraphicsData(updatedGraphicsData);
      }
    } else if (flag === "reset") {
      // Reset if no data found
      setGraphicsData({
        labels: [],
        graph1: { bar1: [], bar2: [], bar3: [], bar4: [] },
        graph2: { line: [], bar1: [], bar2: [] },
        graph3: { line: [], bar1: [], bar2: [], bar3: [] },
        graph4: { line: [], bar1: [], bar2: [] }
      });
    }

    if (flag === "add" || flag === "replace") {
      const label = verticalFilters[2].content.find(item => item.value === playerEval.id).label;
      updatedGraphicsData.labels.push(label);
      updatedGraphicsData.graph1.bar1.push(playerEval.ten_meters);
      updatedGraphicsData.graph1.bar2.push(playerEval.twenty_metersL);
      updatedGraphicsData.graph1.bar3.push(playerEval.thirty_meters);
      updatedGraphicsData.graph1.bar4.push(playerEval.zig_zag);
      updatedGraphicsData.graph2.line.push(playerEval.imc);
      updatedGraphicsData.graph2.bar1.push(playerEval.heightP);
      updatedGraphicsData.graph2.bar2.push(playerEval.weight);
      updatedGraphicsData.graph3.line.push(playerEval.aerobicP);
      updatedGraphicsData.graph3.bar1.push(playerEval.sj);
      updatedGraphicsData.graph3.bar2.push(playerEval.cmj);
      updatedGraphicsData.graph3.bar3.push(playerEval.hj);
      updatedGraphicsData.graph4.line.push(playerEval.avg_anaerobic);
      updatedGraphicsData.graph4.bar1.push(playerEval.worst_anaerobic);
      updatedGraphicsData.graph4.bar2.push(playerEval.best_anaerobic);

      setGraphicsData(updatedGraphicsData);  // Trigger re-render with updated data
    }
  }
  
  const placeBackgroundImages = () => {
    const bckLogo1 = document.getElementById("webapp-create-team-bcklogo1");
    const bckLogo2 = document.getElementById("webapp-create-team-bcklogo2");
    const bckLogo1Height = bckLogo1.offsetHeight;
    bckLogo1.style.top = `calc(60% - ${bckLogo1Height}px)`;
    bckLogo2.style.top = `0%`;
    const bckLogo1Width = bckLogo1.offsetWidth;
    bckLogo1.style.left = `calc(60% - ${bckLogo1Width}px)`;
    bckLogo2.style.left = `75%`;
  }

  useEffect(() => {
    getData();
  },[]);

  useEffect(() => {
    // Select all elements with class 'webapp-db-filters-clickables'
    const scrollableDivs = document.querySelectorAll('.webapp-db-filters-clickables');

    // Loop through each element and apply overflow-y: scroll
    scrollableDivs.forEach(div => {
        div.style.overflowY = 'scroll';
        div.style.height = '18rem';  //
    });
    

    placeBackgroundImages();
    window.addEventListener('resize', placeBackgroundImages);
    return () => {
        window.removeEventListener('resize', placeBackgroundImages);
    }

  }, []);

  return (
    <div className="webapp-evaluations-page-scroll">
        <Sidebar selectedOption="evaluations" />
        <div className="webapp-evaluations-page">
            <TrainingsPageChanger
                selectedPage={1}
                pages={[
                    { label: t('Total'), path: '/webapp/evaluations' },
                    { label: t('Statistics'), path: '/webapp/evaluations-statistics' },
                ]}
            />
            <div className="webapp-create-team-background-images">
                <img src={BckLogo} alt="Logo" className="webapp-create-team-bcklogo" id="webapp-create-team-bcklogo1" />
                <img src={BckLogo} alt="Logo" className="webapp-create-team-bcklogo" id="webapp-create-team-bcklogo2" />
            </div>
            <div className="webapp-evaluations-page-header">
                <h1>{t('Evaluations Statistics')}</h1>
            </div>
            <GraphsEvaluations data={graphicsData} filters={verticalFilters} handle={handleVerticalFilter} type={["radio", "radio", "checkbox"]} selectedEvaluations={selectedEvaluations}/> 
        </div>
    </div>
  );
}

export default EvaluationsStatistics;
